(function () {
  "use strict";

  var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/";

    var overlay = document.querySelector("[data-predictive-search]");
    if (!overlay) {
      return;
    }

    var stringsEl = document.querySelector("[data-predictive-search-strings]");
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};

    var input = overlay.querySelector("[data-predictive-search-input]");
    var form = overlay.querySelector("[data-predictive-search-form]");
    var panel = overlay.querySelector("[data-predictive-search-results-panel]");
    var resultsList = overlay.querySelector("[data-predictive-search-results]");
    var statusEl = overlay.querySelector("[data-predictive-search-status]");
    var footer = overlay.querySelector("[data-predictive-search-footer]");
    var viewAll = overlay.querySelector("[data-predictive-search-view-all]");
    var toggle = document.querySelector("[data-header-search-toggle]");

    var debounceTimer = null;
    var activeRequest = null;
    var MIN_QUERY_LENGTH = 2;

    function getMoneyFormat() {
      if (strings.moneyFormat) {
        return strings.moneyFormat;
      }
      return (window.Shopify && window.Shopify.money_format) || "${{amount}}";
    }

    function formatWithDelimiters(cents, precision, thousands, decimal) {
      var number = (Number(cents) / 100).toFixed(precision || 2);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (thousands || ","));
      var centsPart = parts[1] ? (decimal || ".") + parts[1] : "";
      return dollars + centsPart;
    }

    function formatMoney(cents) {
      var formatString = getMoneyFormat();
      var match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) {
        return formatWithDelimiters(cents, 2) + "";
      }

      var value;
      switch (match[1]) {
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function getProductPriceCents(product) {
      if (product.price_min != null) {
        return Math.round(Number(product.price_min) * 100);
      }
      if (product.price != null && product.price !== "") {
        var numeric = String(product.price).replace(/[^0-9.-]/g, "");
        if (numeric) {
          return Math.round(Number(numeric) * 100);
        }
      }
      return null;
    }

    function isOpen() {
      return overlay.classList.contains("is-open");
    }

    function closeCartAndMenu() {
      document.dispatchEvent(new CustomEvent("cart:close-request"));
      document.dispatchEvent(new CustomEvent("menu:close-request"));
    }

    function openOverlay() {
      closeCartAndMenu();
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "true");
      }
      document.documentElement.style.overflow = "hidden";
      if (input) {
        input.focus();
        if (input.value.trim().length >= MIN_QUERY_LENGTH) {
          fetchResults(input.value.trim());
        }
      }
    }

    function closeOverlay() {
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "false");
      }
      document.documentElement.style.overflow = "";
      hideResults();
      if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = null;
      }
      if (activeRequest) {
        activeRequest.abort();
        activeRequest = null;
      }
    }

    function hideResults() {
      if (panel) {
        panel.classList.add("hidden");
      }
      if (resultsList) {
        resultsList.innerHTML = "";
      }
      if (statusEl) {
        statusEl.classList.add("hidden");
        statusEl.textContent = "";
      }
      if (footer) {
        footer.classList.add("hidden");
      }
    }

    function showPanel() {
      if (panel) {
        panel.classList.remove("hidden");
      }
    }

    function setStatus(message) {
      if (!statusEl) {
        return;
      }
      if (message) {
        statusEl.textContent = message;
        statusEl.classList.remove("hidden");
      } else {
        statusEl.textContent = "";
        statusEl.classList.add("hidden");
      }
    }

    function buildProductPrice(product) {
      var cents = getProductPriceCents(product);
      return cents != null ? formatMoney(cents) : "";
    }

    function renderProducts(products, query) {
      if (!resultsList) {
        return;
      }

      resultsList.innerHTML = "";

      products.forEach(function (product) {
        var li = document.createElement("li");
        var link = document.createElement("a");
        link.href = product.url;
        link.className =
          "flex items-center gap-3 px-4 py-3 hover:bg-text/5 transition-colors";
        link.setAttribute("data-predictive-search-result", "");

        if (product.featured_image && product.featured_image.url) {
          var img = document.createElement("img");
          img.src = product.featured_image.url;
          img.alt = product.featured_image.alt || product.title || "";
          img.width = 56;
          img.height = 56;
          img.loading = "lazy";
          img.decoding = "async";
          img.className =
            "w-14 h-14 shrink-0 rounded-md object-cover bg-text/5";
          link.appendChild(img);
        } else {
          var placeholder = document.createElement("span");
          placeholder.className =
            "w-14 h-14 shrink-0 rounded-md bg-text/5";
          placeholder.setAttribute("aria-hidden", "true");
          link.appendChild(placeholder);
        }

        var textWrap = document.createElement("div");
        textWrap.className = "min-w-0 flex-1";

        var title = document.createElement("p");
        title.className = "font-heading font-medium leading-tight truncate";
        title.textContent = product.title || "";
        textWrap.appendChild(title);

        var price = buildProductPrice(product);
        if (price) {
          var priceEl = document.createElement("p");
          priceEl.className = "mt-0.5 text-sm font-medium text-link";
          priceEl.textContent = price;
          textWrap.appendChild(priceEl);
        }

        link.appendChild(textWrap);
        li.appendChild(link);
        resultsList.appendChild(li);
      });

      if (viewAll && query) {
        viewAll.href = root + "search?q=" + encodeURIComponent(query);
      }
      if (footer) {
        footer.classList.toggle("hidden", products.length === 0);
      }
    }

    function fetchResults(query) {
      if (activeRequest) {
        activeRequest.abort();
      }

      showPanel();
      setStatus(strings.loading || "Searching…");
      if (resultsList) {
        resultsList.innerHTML = "";
      }
      if (footer) {
        footer.classList.add("hidden");
      }

      var url =
        root +
        "search/suggest.json?q=" +
        encodeURIComponent(query) +
        "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide";

      activeRequest = new AbortController();

      fetch(url, {
        headers: { Accept: "application/json" },
        signal: activeRequest.signal,
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error("Search failed");
          }
          return res.json();
        })
        .then(function (data) {
          activeRequest = null;
          var products =
            (data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];

          if (products.length === 0) {
            setStatus(strings.noResults || "No products found.");
            return;
          }

          setStatus("");
          renderProducts(products, query);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") {
            return;
          }
          activeRequest = null;
          setStatus(strings.noResults || "No products found.");
        });
    }

    function scheduleSearch() {
      if (!input) {
        return;
      }

      var query = input.value.trim();

      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      if (query.length < MIN_QUERY_LENGTH) {
        hideResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 280);
    }

    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-header-search-toggle]")) {
        event.preventDefault();
        if (isOpen()) {
          closeOverlay();
        } else {
          openOverlay();
        }
        return;
      }

      if (event.target.closest("[data-predictive-search-close]")) {
        event.preventDefault();
        closeOverlay();
        return;
      }

      if (
        isOpen() &&
        (event.target.closest("[data-predictive-search-backdrop]") ||
          (!overlay.contains(event.target) &&
            !event.target.closest("[data-header-search-toggle]")))
      ) {
        closeOverlay();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) {
        event.preventDefault();
        closeOverlay();
        if (toggle) {
          toggle.focus();
        }
      }
    });

    document.addEventListener("cart:open", closeOverlay);
    document.addEventListener("search:close-request", closeOverlay);

    if (input) {
      input.addEventListener("input", scheduleSearch);
    }

    if (form) {
      form.addEventListener("submit", function () {
        closeOverlay();
      });
    }
})();
